export default __webpack_public_path__ + "static/media/complementary--chevron-right--g3.1dd25331.png";